import 'date-fns';
import React, { useState, useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import ACTION_TYPES from 'redux-lib/actions/actions';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16
  },
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  }
}));

function EffectiveDate() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const states = useSelector(state => {
    return state.globalStates
  })
  const effectiveDate = states.effective_date ? new Date(states.effective_date).toDateString() : null;
  const [ selectedDate, setSelectedDate ] = useState(effectiveDate);

  useEffect(() => {
    setSelectedDate(effectiveDate)
  }, [effectiveDate])

  const updateReduxEffectiveDateState = (date) => {
    dispatch({
      type: ACTION_TYPES.UPDATE_EFFECTIVE_DATE,
      payload: date
    })
    setSelectedDate(date)
  }

  const handleDateChange = (date) => {
    updateReduxEffectiveDateState(date)
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
        <KeyboardDatePicker
          id="effective-date"
          name="effective_date"
          label="Effective Date of Policy"
          format="MM/dd/yyyy"
          value={selectedDate}
          className={ classes.root }
          onChange={handleDateChange}
          InputLabelProps={{
            shrink: true
          }}
          KeyboardButtonProps={{
            'aria-label': 'change effective date',
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
}

export default EffectiveDate;